export default __webpack_public_path__ + "static/media/manufacturing.085f8edb.jpg";